
import React from 'react';
import { Link } from 'react-router-dom';

// List of blog posts sorted by recency (most recent first)
const blogPosts = [
  {
    id: "scholarship-profile",
    title: "How to Build a Strong Scholarship Profile as an International Applicant",
    description: "Strategic approaches to showcase your unique qualities and stand out in the competitive international scholarship arena.",
    image: "/lovable-uploads/893dcdd2-b961-440e-a6cb-cb7f8ba830ae.png",
    date: "May 10, 2025",
    readTime: "13 min read"
  },
  {
    id: "scholarship-tips",
    title: "Top Things to Consider Before Applying for Scholarships to Study in the USA, UK, or Canada",
    description: "Essential guidance for international students applying for scholarships to study abroad. Learn about eligibility requirements, application timelines, and how to strengthen your application.",
    image: "/lovable-uploads/62db0e0e-4ddf-4fdc-a28c-1f54344264d9.png",
    date: "May 5, 2025",
    readTime: "14 min read"
  },
  {
    id: "scholarship-mistakes",
    title: "Common Mistakes International Students Make When Applying for Scholarships",
    description: "Avoid these common pitfalls to increase your chances of securing that life-changing scholarship opportunity.",
    image: "/lovable-uploads/34dfaa0e-8286-4ea0-a58e-c6b4ad67ce09.png",
    date: "May 5, 2025",
    readTime: "11 min read"
  }
];

const Testimonials = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">Your ultimate global mobility companion</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="bg-yellow-50 p-8 rounded-2xl">
            <div className="w-10 h-10 rounded-full bg-yellow-500 text-white flex items-center justify-center mb-4">1</div>
            <h3 className="font-bold text-xl mb-2">Visa-Sponsored Jobs</h3>
            <p className="text-gray-600">
              Instantly access thousands of international job opportunities that come with visa sponsorship, making it easier to start your career abroad.
            </p>
          </div>
          
          <div className="bg-blue-50 p-8 rounded-2xl">
            <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center mb-4">2</div>
            <h3 className="font-bold text-xl mb-2">Visa & Passport Guidance</h3>
            <p className="text-gray-600">
              Receive curated visa and passport information for 190+ countries, with expert support to help you every step of the way.
            </p>
          </div>
          
          <div className="bg-purple-50 p-8 rounded-2xl">
            <div className="w-10 h-10 rounded-full bg-purple-500 text-white flex items-center justify-center mb-4">3</div>
            <h3 className="font-bold text-xl mb-2">Scholarships & Global Education</h3>
            <p className="text-gray-600">
              Discover and apply for scholarships at top universities worldwide, with personalized assistance to maximize your chances of success.
            </p>
          </div>
        </div>
        
        <div className="mt-16">
          <h2 className="text-3xl font-bold mb-8 text-center">Get smarter, with our blog.</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blogPosts.map((post, idx) => (
              <Link to={`/blog/${post.id}`} key={post.id} className="bg-white rounded-xl overflow-hidden shadow-sm block transition-transform duration-300 hover:-translate-y-1">
                <img src={post.image} alt={post.title} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <div className="text-xs text-purple-600 font-semibold mb-2">{post.date}</div>
                  <h3 className="font-bold text-lg mb-2">{post.title}</h3>
                  <p className="text-sm text-gray-600 line-clamp-3 mb-3">{post.description}</p>
                  <div className="text-sm text-gray-500">{post.readTime}</div>
                  <div className="mt-3 text-purple-600">Read article →</div>
                </div>
              </Link>
            ))}
          </div>
          <div className="text-center mt-8">
            <Link to="/blog">
              <button className="border border-gray-300 px-6 py-2 rounded-md text-gray-800 font-medium">
                See all articles
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
